/**
 * Do not edit directly
 * Generated on Fri, 20 Oct 2023 11:57:24 GMT
 */

export const LightMode = {
  additional: {
    text: {
      primary: "rgba(184, 138, 0, 1)",
      secondary: "rgba(221, 29, 33, 1)",
      tertiary: "rgba(75, 120, 170, 1)",
      positive: "rgba(0, 133, 87, 1)",
      negative: "rgba(221, 29, 33, 1)",
      warning: "rgba(178, 95, 0, 1)",
      information: "rgba(75, 120, 170, 1)",
      inactive: "rgba(224, 224, 224, 1)",
      link: "rgba(75, 120, 170, 1)",
      hover: "rgba(110, 148, 192, 1)",
      visited: "rgba(154, 96, 164, 1)",
    },
    border: {
      primary: "rgba(184, 138, 0, 1)",
      secondary: "rgba(251, 89, 78, 1)",
      tertiary: "rgba(110, 148, 192, 1)",
      positive: "rgba(68, 162, 118, 1)",
      negative: "rgba(251, 89, 78, 1)",
      warning: "rgba(216, 121, 0, 1)",
      information: "rgba(110, 148, 192, 1)",
      selected: "rgba(0, 127, 162, 1)",
    },
    focus: {
      strong: "rgba(0, 151, 187, 1)",
      subtle: "rgba(0, 128, 163, 0.39)",
    },
    mask: {
      strong: "rgba(28, 28, 28, 0.49)",
      subtle: "rgba(28, 28, 28, 0.28)",
    },
    series: {
      1: "rgba(0, 151, 169, 1)",
      2: "rgba(51, 96, 148, 1)",
      3: "rgba(154, 96, 164, 1)",
      4: "rgba(213, 68, 16, 1)",
      5: "rgba(237, 138, 0, 1)",
      6: "rgba(255, 198, 0, 1)",
      7: "rgba(143, 183, 83, 1)",
      8: "rgba(0, 133, 87, 1)",
      9: "rgba(129, 204, 217, 1)",
      10: "rgba(110, 148, 192, 1)",
      11: "rgba(195, 158, 201, 1)",
      12: "rgba(255, 137, 102, 1)",
      13: "rgba(255, 218, 174, 1)",
      14: "rgba(255, 223, 85, 1)",
      15: "rgba(201, 236, 154, 1)",
      16: "rgba(111, 185, 147, 1)",
    },
  },
  onSurface: {
    surface: {
      default: {
        background: "rgba(255, 255, 255, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(117, 117, 117, 1)",
        },
        border: {
          strong: "rgba(52, 52, 52, 1)",
          medium: "rgba(145, 145, 145, 1)",
          subtle: "rgba(224, 224, 224, 1)",
        },
      },
      hover: {
        background: "rgba(245, 245, 245, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(97, 97, 97, 1)",
        },
        border: {
          strong: "rgba(52, 52, 52, 1)",
          medium: "rgba(117, 117, 117, 1)",
          subtle: "rgba(224, 224, 224, 1)",
        },
      },
      active: {
        background: "rgba(224, 224, 224, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(97, 97, 97, 1)",
        },
        border: {
          strong: "rgba(52, 52, 52, 1)",
          medium: "rgba(117, 117, 117, 1)",
          subtle: "rgba(192, 192, 192, 1)",
        },
      },
    },
    elevated: {
      default: {
        background: "rgba(255, 255, 255, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(117, 117, 117, 1)",
        },
        border: {
          strong: "rgba(52, 52, 52, 1)",
          medium: "rgba(145, 145, 145, 1)",
          subtle: "rgba(224, 224, 224, 1)",
        },
      },
      hover: {
        background: "rgba(245, 245, 245, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(97, 97, 97, 1)",
        },
        border: {
          strong: "rgba(52, 52, 52, 1)",
          medium: "rgba(117, 117, 117, 1)",
          subtle: "rgba(224, 224, 224, 1)",
        },
      },
      active: {
        background: "rgba(224, 224, 224, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(97, 97, 97, 1)",
        },
        border: {
          strong: "rgba(52, 52, 52, 1)",
          medium: "rgba(117, 117, 117, 1)",
          subtle: "rgba(192, 192, 192, 1)",
        },
      },
    },
    base: {
      default: {
        background: "rgba(245, 245, 245, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(97, 97, 97, 1)",
        },
        border: {
          strong: "rgba(41, 41, 41, 1)",
          medium: "rgba(117, 117, 117, 1)",
          subtle: "rgba(192, 192, 192, 1)",
        },
      },
      hover: {
        background: "rgba(224, 224, 224, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(74, 74, 74, 1)",
        },
        border: {
          strong: "rgba(41, 41, 41, 1)",
          medium: "rgba(117, 117, 117, 1)",
          subtle: "rgba(192, 192, 192, 1)",
        },
      },
      active: {
        background: "rgba(192, 192, 192, 1)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(74, 74, 74, 1)",
        },
        border: {
          strong: "rgba(41, 41, 41, 1)",
          medium: "rgba(97, 97, 97, 1)",
          subtle: "rgba(170, 170, 170, 1)",
        },
      },
    },
    section: {
      default: {
        background: "rgba(28, 28, 28, 0.04)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(97, 97, 97, 1)",
        },
        border: {
          strong: "rgba(41, 41, 41, 1)",
          medium: "rgba(117, 117, 117, 1)",
          subtle: "rgba(192, 192, 192, 1)",
        },
      },
      hover: {
        background: "rgba(28, 28, 28, 0.14)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(74, 74, 74, 1)",
        },
        border: {
          strong: "rgba(41, 41, 41, 1)",
          medium: "rgba(117, 117, 117, 1)",
          subtle: "rgba(192, 192, 192, 1)",
        },
      },
      active: {
        background: "rgba(28, 28, 28, 0.28)",
        text: {
          strong: "rgba(41, 41, 41, 1)",
          subtle: "rgba(74, 74, 74, 1)",
        },
        border: {
          strong: "rgba(41, 41, 41, 1)",
          medium: "rgba(97, 97, 97, 1)",
          subtle: "rgba(170, 170, 170, 1)",
        },
      },
    },
    inactive: {
      default: {
        background: "rgba(245, 245, 245, 1)",
        text: {
          strong: "rgba(97, 97, 97, 1)",
          subtle: "rgba(170, 170, 170, 1)",
        },
        border: {
          strong: "rgba(117, 117, 117, 1)",
          medium: "rgba(192, 192, 192, 1)",
          subtle: "rgba(224, 224, 224, 1)",
        },
      },
      hover: {
        background: "rgba(245, 245, 245, 1)",
        text: {
          strong: "rgba(97, 97, 97, 1)",
          subtle: "rgba(170, 170, 170, 1)",
        },
        border: {
          strong: "rgba(117, 117, 117, 1)",
          medium: "rgba(192, 192, 192, 1)",
          subtle: "rgba(224, 224, 224, 1)",
        },
      },
      active: {
        background: "rgba(245, 245, 245, 1)",
        text: {
          strong: "rgba(97, 97, 97, 1)",
          subtle: "rgba(170, 170, 170, 1)",
        },
        border: {
          strong: "rgba(117, 117, 117, 1)",
          medium: "rgba(192, 192, 192, 1)",
          subtle: "rgba(224, 224, 224, 1)",
        },
      },
    },
  },
  onSentiment: {
    default: {
      strong: {
        primary: {
          default: {
            background: "rgba(255, 198, 0, 1)",
            text: {
              default: "rgba(28, 28, 28, 0.94)",
              colour: "rgba(28, 28, 28, 0.94)",
            },
            border: {
              default: "rgba(28, 28, 28, 0.94)",
              colour: "rgba(28, 28, 28, 0.94)",
            },
          },
          hover: {
            background: "rgba(214, 162, 0, 1)",
            text: {
              default: "rgba(28, 28, 28, 0.94)",
              colour: "rgba(28, 28, 28, 0.94)",
            },
            border: {
              default: "rgba(28, 28, 28, 0.94)",
              colour: "rgba(28, 28, 28, 0.94)",
            },
          },
          active: {
            background: "rgba(184, 138, 0, 1)",
            text: {
              default: "rgba(28, 28, 28, 0.94)",
              colour: "rgba(28, 28, 28, 0.94)",
            },
            border: {
              default: "rgba(28, 28, 28, 0.94)",
              colour: "rgba(28, 28, 28, 0.94)",
            },
          },
        },
        secondary: {
          default: {
            background: "rgba(221, 29, 33, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(197, 0, 13, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(153, 0, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        tertiary: {
          default: {
            background: "rgba(75, 120, 170, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(51, 96, 148, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(32, 75, 122, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        neutral: {
          default: {
            background: "rgba(117, 117, 117, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(97, 97, 97, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(74, 74, 74, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        positive: {
          default: {
            background: "rgba(0, 133, 87, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(0, 111, 69, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(0, 85, 49, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        negative: {
          default: {
            background: "rgba(221, 29, 33, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(197, 0, 13, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(153, 0, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        warning: {
          default: {
            background: "rgba(178, 95, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(150, 78, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(117, 58, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        information: {
          default: {
            background: "rgba(75, 120, 170, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(51, 96, 148, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(32, 75, 122, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        selected: {
          default: {
            background: "rgba(0, 127, 162, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(0, 105, 139, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(0, 79, 113, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
      },
      subtle: {
        primary: {
          default: {
            background: "rgba(255, 247, 180, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(125, 91, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(125, 91, 0, 1)",
            },
          },
          hover: {
            background: "rgba(255, 223, 85, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(96, 69, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(96, 69, 0, 1)",
            },
          },
          active: {
            background: "rgba(255, 198, 0, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(96, 69, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(96, 69, 0, 1)",
            },
          },
        },
        secondary: {
          default: {
            background: "rgba(255, 242, 240, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
          },
          hover: {
            background: "rgba(255, 214, 208, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
          },
          active: {
            background: "rgba(255, 172, 160, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
          },
        },
        tertiary: {
          default: {
            background: "rgba(241, 244, 249, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
          },
          hover: {
            background: "rgba(214, 225, 239, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
          active: {
            background: "rgba(172, 195, 222, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
        },
        neutral: {
          default: {
            background: "rgba(245, 245, 245, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
          hover: {
            background: "rgba(224, 224, 224, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
          active: {
            background: "rgba(192, 192, 192, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
          },
        },
        positive: {
          default: {
            background: "rgba(239, 247, 242, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 111, 69, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 111, 69, 1)",
            },
          },
          hover: {
            background: "rgba(203, 230, 215, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
          },
          active: {
            background: "rgba(151, 205, 175, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
          },
        },
        negative: {
          default: {
            background: "rgba(255, 242, 240, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
          },
          hover: {
            background: "rgba(255, 214, 208, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
          },
          active: {
            background: "rgba(255, 172, 160, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
          },
        },
        warning: {
          default: {
            background: "rgba(255, 243, 229, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(150, 78, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(150, 78, 0, 1)",
            },
          },
          hover: {
            background: "rgba(255, 218, 174, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
          },
          active: {
            background: "rgba(255, 177, 91, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
          },
        },
        information: {
          default: {
            background: "rgba(241, 244, 249, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
          },
          hover: {
            background: "rgba(214, 225, 239, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
          active: {
            background: "rgba(172, 195, 222, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
        },
        selected: {
          default: {
            background: "rgba(238, 246, 249, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 105, 139, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 105, 139, 1)",
            },
          },
          hover: {
            background: "rgba(202, 228, 238, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 79, 113, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 79, 113, 1)",
            },
          },
          active: {
            background: "rgba(149, 201, 220, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 79, 113, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 79, 113, 1)",
            },
          },
        },
      },
      transparent: {
        primary: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(149, 111, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(149, 111, 0, 1)",
            },
          },
          hover: {
            background: "rgba(255, 247, 180, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(125, 91, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(96, 69, 0, 1)",
            },
          },
          active: {
            background: "rgba(255, 223, 85, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(96, 69, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(96, 69, 0, 1)",
            },
          },
        },
        secondary: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
          },
          hover: {
            background: "rgba(255, 242, 240, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
          },
          active: {
            background: "rgba(255, 214, 208, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
          },
        },
        tertiary: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(75, 120, 170, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(75, 120, 170, 1)",
            },
          },
          hover: {
            background: "rgba(241, 244, 249, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
          },
          active: {
            background: "rgba(214, 225, 239, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
        },
        neutral: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(245, 245, 245, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
          active: {
            background: "rgba(224, 224, 224, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
          },
        },
        positive: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 133, 87, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 133, 87, 1)",
            },
          },
          hover: {
            background: "rgba(239, 247, 242, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 111, 69, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 111, 69, 1)",
            },
          },
          active: {
            background: "rgba(203, 230, 215, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
          },
        },
        negative: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
          },
          hover: {
            background: "rgba(255, 242, 240, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
          },
          active: {
            background: "rgba(255, 214, 208, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
          },
        },
        warning: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(178, 95, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(178, 95, 0, 1)",
            },
          },
          hover: {
            background: "rgba(255, 243, 229, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(150, 78, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(150, 78, 0, 1)",
            },
          },
          active: {
            background: "rgba(255, 218, 174, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
          },
        },
        information: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(75, 120, 170, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(75, 120, 170, 1)",
            },
          },
          hover: {
            background: "rgba(241, 244, 249, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
          },
          active: {
            background: "rgba(214, 225, 239, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
        },
        selected: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 127, 162, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 127, 162, 1)",
            },
          },
          hover: {
            background: "rgba(237, 247, 249, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 105, 139, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 105, 139, 1)",
            },
          },
          active: {
            background: "rgba(202, 228, 238, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 79, 113, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 79, 113, 1)",
            },
          },
        },
      },
    },
    muted: {
      strong: {
        primary: {
          default: {
            background: "rgba(74, 74, 74, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
          hover: {
            background: "rgba(52, 52, 52, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
          active: {
            background: "rgba(41, 41, 41, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
        },
        secondary: {
          default: {
            background: "rgba(74, 74, 74, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
          hover: {
            background: "rgba(52, 52, 52, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
          active: {
            background: "rgba(41, 41, 41, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
        },
        tertiary: {
          default: {
            background: "rgba(74, 74, 74, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
          hover: {
            background: "rgba(52, 52, 52, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
          active: {
            background: "rgba(41, 41, 41, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
        },
        neutral: {
          default: {
            background: "rgba(117, 117, 117, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(97, 97, 97, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(74, 74, 74, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        positive: {
          default: {
            background: "rgba(0, 133, 87, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(0, 111, 69, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(0, 85, 49, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        negative: {
          default: {
            background: "rgba(221, 29, 33, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(197, 0, 13, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(153, 0, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        warning: {
          default: {
            background: "rgba(178, 95, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(150, 78, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(117, 58, 0, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        information: {
          default: {
            background: "rgba(75, 120, 170, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          hover: {
            background: "rgba(51, 96, 148, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
          active: {
            background: "rgba(32, 75, 122, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 1)",
            },
          },
        },
        selected: {
          default: {
            background: "rgba(74, 74, 74, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
          hover: {
            background: "rgba(52, 52, 52, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
          active: {
            background: "rgba(41, 41, 41, 1)",
            text: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.75)",
            },
            border: {
              default: "rgba(255, 255, 255, 1)",
              colour: "rgba(255, 255, 255, 0.49)",
            },
          },
        },
      },
      subtle: {
        primary: {
          default: {
            background: "rgba(28, 28, 28, 0.04)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(28, 28, 28, 0.14)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
          active: {
            background: "rgba(28, 28, 28, 0.28)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
        },
        secondary: {
          default: {
            background: "rgba(28, 28, 28, 0.04)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(28, 28, 28, 0.14)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          active: {
            background: "rgba(28, 28, 28, 0.28)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
        },
        tertiary: {
          default: {
            background: "rgba(28, 28, 28, 0.04)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(28, 28, 28, 0.14)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          active: {
            background: "rgba(28, 28, 28, 0.28)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
        },
        neutral: {
          default: {
            background: "rgba(245, 245, 245, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
          hover: {
            background: "rgba(224, 224, 224, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
          active: {
            background: "rgba(192, 192, 192, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
          },
        },
        positive: {
          default: {
            background: "rgba(239, 247, 242, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 111, 69, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 111, 69, 1)",
            },
          },
          hover: {
            background: "rgba(203, 230, 215, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
          },
          active: {
            background: "rgba(151, 205, 175, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
          },
        },
        negative: {
          default: {
            background: "rgba(255, 242, 240, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
          },
          hover: {
            background: "rgba(255, 214, 208, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
          },
          active: {
            background: "rgba(255, 172, 160, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
          },
        },
        warning: {
          default: {
            background: "rgba(255, 243, 229, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(150, 78, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(150, 78, 0, 1)",
            },
          },
          hover: {
            background: "rgba(255, 218, 174, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
          },
          active: {
            background: "rgba(255, 177, 91, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
          },
        },
        information: {
          default: {
            background: "rgba(241, 244, 249, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
          },
          hover: {
            background: "rgba(214, 225, 239, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
          active: {
            background: "rgba(172, 195, 222, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
        },
        selected: {
          default: {
            background: "rgba(28, 28, 28, 0.04)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(28, 28, 28, 0.14)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          active: {
            background: "rgba(28, 28, 28, 0.28)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
        },
      },
      transparent: {
        primary: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(245, 245, 245, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          active: {
            background: "rgba(224, 224, 224, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
        },
        secondary: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(245, 245, 245, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          active: {
            background: "rgba(224, 224, 224, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
        },
        tertiary: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(245, 245, 245, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          active: {
            background: "rgba(224, 224, 224, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
        },
        neutral: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(245, 245, 245, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
          },
          active: {
            background: "rgba(224, 224, 224, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
          },
        },
        positive: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 133, 87, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 133, 87, 1)",
            },
          },
          hover: {
            background: "rgba(239, 247, 242, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 111, 69, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 111, 69, 1)",
            },
          },
          active: {
            background: "rgba(203, 230, 215, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(0, 85, 49, 1)",
            },
          },
        },
        negative: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
          },
          hover: {
            background: "rgba(255, 242, 240, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(197, 0, 13, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(221, 29, 33, 1)",
            },
          },
          active: {
            background: "rgba(255, 214, 208, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(153, 0, 0, 1)",
            },
          },
        },
        warning: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(178, 95, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(178, 95, 0, 1)",
            },
          },
          hover: {
            background: "rgba(255, 243, 229, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(150, 78, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(150, 78, 0, 1)",
            },
          },
          active: {
            background: "rgba(255, 218, 174, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 58, 0, 1)",
            },
          },
        },
        information: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(75, 120, 170, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(75, 120, 170, 1)",
            },
          },
          hover: {
            background: "rgba(241, 244, 249, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(51, 96, 148, 1)",
            },
          },
          active: {
            background: "rgba(214, 225, 239, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(32, 75, 122, 1)",
            },
          },
        },
        selected: {
          default: {
            background: "rgba(255, 255, 255, 0)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          hover: {
            background: "rgba(245, 245, 245, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(97, 97, 97, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
          active: {
            background: "rgba(224, 224, 224, 1)",
            text: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(74, 74, 74, 1)",
            },
            border: {
              default: "rgba(41, 41, 41, 1)",
              colour: "rgba(117, 117, 117, 1)",
            },
          },
        },
      },
    },
  },
  accent: {
    primary: {
      strong: "rgba(255, 198, 0, 1)",
      medium: "rgba(255, 223, 85, 1)",
      subtle: "rgba(255, 247, 180, 1)",
    },
    secondary: {
      strong: "rgba(221, 29, 33, 1)",
      medium: "rgba(251, 89, 78, 1)",
      subtle: "rgba(255, 172, 160, 1)",
    },
    tertiary: {
      strong: "rgba(51, 96, 148, 1)",
      medium: "rgba(110, 148, 192, 1)",
      subtle: "rgba(172, 195, 222, 1)",
    },
  },
  background: {
    surface: "rgba(255, 255, 255, 1)",
    raised: "rgba(255, 255, 255, 1)",
    base: "rgba(245, 245, 245, 1)",
    section: "rgba(28, 28, 28, 0.04)",
    inactive: "rgba(245, 245, 245, 1)",
    inverted: "rgba(64, 64, 64, 1)",
    mask: "rgba(28, 28, 28, 0.28)",
  },
  border: {
    strong: "rgba(28, 28, 28, 0.38)",
    medium: "rgba(28, 28, 28, 0.14)",
    subtle: "rgba(28, 28, 28, 0.04)",
  },
  text: {
    onSurface: {
      strong: "rgba(52, 52, 52, 1)",
      subtle: "rgba(117, 117, 117, 1)",
      inactive: "rgba(224, 224, 224, 1)",
      link: "rgba(51, 96, 148, 1)",
      hover: "rgba(110, 148, 192, 1)",
      visited: "rgba(132, 75, 142, 1)",
      positive: "rgba(0, 133, 87, 1)",
      negative: "rgba(221, 29, 33, 1)",
      warning: "rgba(178, 95, 0, 1)",
      information: "rgba(75, 120, 170, 1)",
    },
    onInverted: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(255, 255, 255, 0.6)",
      inactive: "rgba(255, 255, 255, 0.26)",
      link: "rgba(143, 173, 209, 1)",
      hover: "rgba(75, 120, 170, 1)",
      visited: "rgba(195, 158, 201, 1)",
    },
    onPrimary: {
      strong: "rgba(52, 52, 52, 1)",
      subtle: "rgba(97, 97, 97, 1)",
      inactive: "rgba(28, 28, 28, 0.28)",
      link: "rgba(74, 74, 74, 1)",
    },
    onSecondary: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(255, 255, 255, 1)",
      inactive: "rgba(255, 255, 255, 0.49)",
      link: "rgba(255, 255, 255, 1)",
    },
    onTertiary: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(255, 255, 255, 1)",
      inactive: "rgba(255, 255, 255, 0.25)",
      link: "rgba(255, 255, 255, 1)",
    },
    onFocus: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(28, 28, 28, 0.8)",
      inactive: "rgba(28, 28, 28, 0.28)",
      link: "rgba(28, 28, 28, 0.8)",
    },
    onBase: {
      strong: "rgba(41, 41, 41, 1)",
      subtle: "rgba(97, 97, 97, 1)",
      inactive: "rgba(192, 192, 192, 1)",
      link: "rgba(51, 96, 148, 1)",
      hover: "rgba(110, 148, 192, 1)",
      visited: "rgba(132, 75, 142, 1)",
    },
    onSystem: {
      strong: {
        neutral: "rgba(255, 255, 255, 1)",
        positive: "rgba(255, 255, 255, 1)",
        negative: "rgba(255, 255, 255, 1)",
        warning: "rgba(74, 74, 74, 1)",
        information: "rgba(255, 255, 255, 1)",
      },
      subtle: {
        neutral: "rgba(97, 97, 97, 1)",
        positive: "rgba(0, 133, 87, 1)",
        negative: "rgba(221, 29, 33, 1)",
        warning: "rgba(178, 95, 0, 1)",
        information: "rgba(75, 120, 170, 1)",
      },
    },
  },
  system: {
    strong: {
      neutral: "rgba(97, 97, 97, 1)",
      positive: "rgba(0, 133, 87, 1)",
      negative: "rgba(221, 29, 33, 1)",
      warning: "rgba(255, 177, 91, 1)",
      information: "rgba(75, 120, 170, 1)",
    },
    subtle: {
      neutral: "rgba(245, 245, 245, 1)",
      positive: "rgba(239, 247, 242, 1)",
      negative: "rgba(255, 242, 240, 1)",
      warning: "rgba(255, 243, 229, 1)",
      information: "rgba(241, 244, 249, 1)",
    },
  },
  focus: {
    strong: "rgba(0, 151, 169, 1)",
    medium: "rgba(0, 131, 148, 0.78)",
    subtle: "rgba(0, 151, 168, 0.39)",
    extraSubtle: "rgba(0, 151, 168, 0.1)",
  },
  series: {
    1: "rgba(0, 151, 169, 1)",
    2: "rgba(51, 96, 148, 1)",
    3: "rgba(154, 96, 164, 1)",
    4: "rgba(221, 29, 33, 1)",
    5: "rgba(237, 138, 0, 1)",
    6: "rgba(255, 198, 0, 1)",
    7: "rgba(143, 183, 83, 1)",
    8: "rgba(0, 133, 87, 1)",
    9: "rgba(129, 204, 217, 1)",
    10: "rgba(110, 148, 192, 1)",
    11: "rgba(195, 158, 201, 1)",
    12: "rgba(255, 136, 123, 1)",
    13: "rgba(255, 218, 174, 1)",
    14: "rgba(255, 223, 85, 1)",
    15: "rgba(201, 236, 154, 1)",
    16: "rgba(111, 185, 147, 1)",
  },
  elevation: {
    level0: "0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.1)",
    level1: "0px 2px 5px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.1)",
    level2: "0px 6px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.1)",
    level3:
      "0px 10px 40px rgba(0, 0, 0, 0.08), 0px 4px 12px rgba(0, 0, 0, 0.1)",
    level4:
      "0px 20px 64px rgba(0, 0, 0, 0.12), 0px 16px 24px rgba(0, 0, 0, 0.08)",
    level5:
      "0px 24px 80px rgba(0, 0, 0, 0.16), 0px 16px 32px rgba(0, 0, 0, 0.06)",
  },
};
